import type { CSSProperties, ReactNode } from 'react';
import './CardShell.css';

type Props = {
  isActive: boolean;
  /** compact = Tarjetas' tighter padding/gap; spacious = Letras/Sílabas' airier one. */
  size?: 'compact' | 'spacious';
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

/**
 * Shared visual shell for the flashcard-carousel family (Tarjetas, Letras,
 * Sílabas): size/radius/surface/border and the inactive↔active scale+opacity+
 * shadow transition — previously triplicated across DetailView/LetrasView/
 * SilabasView CSS. Content-specific styling (image area, word text, color
 * variants, etc.) stays in each caller via `className`.
 */
export function CardShell({ isActive, size = 'compact', className, style, children }: Props) {
  const classes = [
    'card-shell',
    `card-shell--${size}`,
    isActive ? 'is-active' : '',
    className ?? '',
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
}
